<template>
  <WdsStack direction-column gap-xs :data-test="dataTest">
    <component
      :is="hideAvatar ? WdsStack : WdsAvatarLabel"
      :class="hideAvatar ? 'tw-min-w-0' : 'client-contact'"
      :direction-column="hideAvatar || undefined"
    >
      <template v-if="!hideAvatar" #avatar>
        <AvatarWithFallback :id="contact.id" :avatar="contact.avatar" md />
      </template>

      <WdsStack direction-column class="tw-min-w-0">
        <WdsStack align-center gap-sm class="tw-pl-1">
          <WdsText :text="contact.name" :large="!sm" />
          <WdsText v-if="note" tertiary small class="tw-whitespace-nowrap">{{ note }}</WdsText>
          <slot name="badge" />
        </WdsStack>

        <WdsStack direction-column class="tw-min-w-0 contact-lines">
          <CopyableText
            v-if="contact.email"
            secondary
            :text="contact.email"
            :data-test="`${dataTest}-email`"
          />
          <PhoneNumber
            v-if="contact.phone"
            copyable
            secondary
            :phone="contact.phone"
            :data-test="`${dataTest}-phone`"
          />
        </WdsStack>
      </WdsStack>
    </component>
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsAvatarLabel, WdsStack, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import AvatarWithFallback from '@/components/AvatarWithFallback.vue'
import CopyableText from '@/components/CopyableText.vue'
import PhoneNumber from '@/components/PhoneNumber.vue'

const ClientContactLabelFields = graphql(`
  fragment ClientContactLabel on User {
    id
    name
    email
    phone
    avatar
  }
`)

const props = withDefaults(
  defineProps<{
    contact: FragmentType<typeof ClientContactLabelFields>
    note?: string
    sm?: boolean
    hideAvatar?: boolean
    dataTest?: string
  }>(),
  {
    note: undefined,
    sm: false,
    hideAvatar: false,
    dataTest: 'client-contact',
  },
)

const contact = computed(() => useFragment(ClientContactLabelFields, props.contact))
</script>

<style scoped lang="scss">
.client-contact.wds-stack-align-center {
  align-items: flex-start;
}
</style>
